export default {
  init (vue) {
    return {
      /**
       * 带选号的小白卡下单
       * for 陕西电信
       * POST Form
       */
      createCardOrderXbk (formData) {
        return vue.$http({
          method: 'POST',
          url: `/pages/sndx/card/createCardOrderXbk`,
          withCredentials: true,
          headers: {'Content-Type': 'multipart/form-data'},
          data: formData
        })
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/service/shaanxi.service.js